/*
 * Terms and conditions login page
 *
 * This contains terms and condition
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { FaithTheme } from 'theme';
import ConsentManagementModal from './ConsentManagementModal';
import TermsAndConditionsViewer from './TermsAndConditionsViewer/TermsAndConditionsViewer';

/**
 * Displays terms and conditions page
 */
function TermsAndConditionsPage({
  theme = FaithTheme,
  openModal = false,
  effectiveDate = '',
  isConsentFlow = true,
}) {
  React.useEffect(() => {
    if (isConsentFlow) {
      return undefined;
    }

    document.body.classList.add('terms-page');

    return () => {
      document.body.classList.remove('terms-page');
    };
  }, [isConsentFlow]);

  const termsURL = 'Terms_and_Conditions_11-13-2024.pdf';
  const licenseURL = 'License_Agreement.pdf';

  if (isConsentFlow) {
    return (
      <ThemeProvider theme={theme}>
        <ConsentManagementModal
          effectiveDate={effectiveDate}
          licenseURL={licenseURL}
          openModal={openModal}
          termsURL={termsURL}
        />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          padding: { xs: 1.6, sm: 4 },
          backgroundColor: '#f5f5f5',
          minHeight: '100vh',
          width: '100%',
        }}
      >
        <Paper sx={{ padding: { xs: 1.6, sm: 4 }, maxWidth: '960px', margin: 'auto' }}>
          <TermsAndConditionsViewer documents={[termsURL]} currentPage={0} />

          <TermsAndConditionsViewer documents={[licenseURL]} currentPage={0} />
        </Paper>
      </Box>
    </ThemeProvider>
  );
}

TermsAndConditionsPage.propTypes = {
  theme: PropTypes.object,
  openModal: PropTypes.bool,
  effectiveDate: PropTypes.string,
  isConsentFlow: PropTypes.bool,
};

export default TermsAndConditionsPage;
